// Module
var code = "<div id=\"V-C67B9C85-D5E5-4DB8-802C-A0876EB9095C\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding Content}\" class=\"stretch-content\"> </div> </div> ";
// Exports
export default code;